import React, { type FC, useState } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import SuggestionRadioSelector from "./SuggestionRadioSelector";
import { type Prize } from "kadow-jetpack-model";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Modal_2 from "../../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import "./styles.scss";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import { tt } from "../../../../utils/i18n/i18n";
interface Props {}

const GiftSuggestionModal: FC<Props & NiceModalHocProps> =
  NiceModal.create<Props>((props) => {
    const modal = useModal();
    const [selectedOption, setSelectedOption] = useState<Partial<Prize> | null>(
      null
    );

    const handleSelection = (value: Partial<Prize>) => {
      setSelectedOption(value);
    };

    const handleClose = () => {
      modal.resolve(selectedOption);
      modal.hide();
    };

    return (
      <KC_Modal_2
        isOpen={modal.visible}
        onClose={handleClose}
        className={"gift-suggestion-modal"}
        header={
          <div className={"p-3"}>
            <KC_Heading2
              text={tt("generate_gift_ideas")}
              className="display-lg"
            />
            <KC_Heading3
              text={tt("generate_gift_ideas")}
              className="display-sm"
            />
          </div>
        }
        footer={
          <div className={"w-100 p-3 d-flex st-gap justify-content-end"}>
            <KC_Button
              text={tt("cancel_button")}
              size={KC_ButtonSize.Large}
              type={KC_ButtonType.Button}
              isInverted={true}
              onClick={modal.hide}
              className="w-lg-25 w-sm-50 border d-flex"
            />
            <KC_Button
              text={tt("validate_button")}
              size={KC_ButtonSize.Large}
              isPrimary={true}
              type={KC_ButtonType.Button}
              onClick={handleClose}
              className="w-lg-25 w-sm-50 d-flex"
            />
          </div>
        }
      >
        <div className="p-3 d-flex flex-column gap-lg">
          <KC_UIText
            weight={KC_Weights.reg}
            text={tt("gift_suggestions_description")}
          />
          <SuggestionRadioSelector
            onSelect={handleSelection}
            value={selectedOption}
          />
        </div>
      </KC_Modal_2>
    );
  });

export default GiftSuggestionModal;
